import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getConfig} from 'mattermost-redux/selectors/entities/general';

import {uploadFile} from 'actions/file_actions';
import {getCurrentLocale} from 'selectors/i18n';
import {canUploadFiles} from 'utils/file_utils';

import type {GlobalState} from 'types/store';

import type {AppDispatch} from 'stores/redux_store';

import Constants from 'utils/constants';
import * as Utils from 'utils/utils';

import FileUpload from './file_upload';

function mapStateToProps(state: GlobalState) {
    const config = getConfig(state);
    const maxFileSize =
        typeof config.MaxFileSize === 'undefined' ? Number.MAX_SAFE_INTEGER : parseInt(config.MaxFileSize, 10);
    const newEditorEnabled = Utils.isFeatureEnabled(Constants.PRE_RELEASE_FEATURES.NEW_EDITOR, state);

    return {
        maxFileSize,
        canUploadFiles: canUploadFiles(config),
        locale: getCurrentLocale(state),
        pluginFileUploadMethods: state.plugins.components.FileUploadMethod,
        pluginFilesWillUploadHooks: state.plugins.components.FilesWillUploadHook,
        newEditorEnabled,
    };
}

function mapDispatchToProps(dispatch: AppDispatch) {
    return {
        actions: bindActionCreators(
            {uploadFile},
            dispatch,
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FileUpload);
